import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppInsightsService } from '@markpieszak/ng-application-insights';

@Injectable()
export class CustomGuard implements CanActivate {

    constructor(public appInsightsService: AppInsightsService) { }

    canActivate(next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        if (this.appInsightsService.context) {
            this.appInsightsService.context.addTelemetryInitializer(
                (envelope) => {
                  const usuarioLogado = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["nomeUsuario"];
                    envelope.userId = usuarioLogado;

                    if (envelope.tags) {
                        envelope.tags['ai.user.id'] = usuarioLogado;
                    }
                })
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.guard.ts